import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Book from "@/pages/Book";
import MyBookings from "@/pages/MyBookings";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";
import Privacy from "@/pages/Privacy";
import Cookie from "@/pages/Cookie";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Account from "@/pages/Account";
import ChiSiamo from "@/pages/ChiSiamo";
import { CookieBanner } from "@/components/CookieBanner";
import { WhatsAppFab } from "@/components/WhatsAppFab";

function AppRouter() {
  const loc = useLocation();
  // Handle Google OAuth session_id in URL fragment before any other routing
  if (loc.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <Navbar />
      <main className="min-h-[calc(100vh-4rem)]">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registrati" element={<Register />} />
          <Route path="/prenota" element={<Book />} />
          <Route path="/le-mie-prenotazioni" element={<MyBookings />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/password-dimenticata" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/account" element={<Account />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie" element={<Cookie />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
      <WhatsAppFab />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
